import React from 'react';
import Navbar from "../component/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import { lan } from "../lan/index.js";
import MetaTags from '../component/MetaTags.jsx';

const PrivacyPolicy = () => {
  const data = lan.en;
  return (
    <>
    <Navbar />
    
    <div className="container">
    <div className="centered-content">

      <h1>Privacy Policy</h1>

      <h4>1. Information We Collect</h4>
      <p>We may collect personal information that you provide directly when you use our services.</p>

      <h4>2. How We Use Your Information</h4>
      <p>We may use the information we collect for various purposes, including:</p>
      <ul>
        <li>Providing and maintaining our services.</li>
        <li>Notifying you about changes to our services.</li>
        <li>Allowing you to participate in interactive features of our services when you choose to do so.</li>
        <li>Providing customer support.</li>
        {/* Add more purposes as necessary */}
      </ul>

      <h4>3. Cookies</h4>
      <p>We use cookies to improve your experience on our site. By using our site, you consent to the use of cookies.</p>

      <h4>4. Security</h4>
      <p>We take reasonable steps to protect your personal information. However, no method of transmission over the internet is entirely secure.</p>

      <h4>5. Koderbox Meet Recorder (Chrome Extension)</h4>
      <p>Koderbox Meet Recorder is a Chrome extension used by Koderbox trainers to record live classes conducted on Google Meet.</p>

      <p><strong>What it records:</strong> with the trainer's own action (clicking Start Recording, or an enabled automatic-start setting), the extension captures the class video, the trainer's microphone audio, and available Meet/system audio, and saves the result as a video file on the trainer's own computer.</p>

      <p><strong>Sign-in and upload:</strong> trainer accounts are created only by Koderbox administrators — there is no public sign-up. If a trainer signs in to their Koderbox account and selects a class, the extension additionally uploads the finished recording to Koderbox's own class-management platform, associating it with that class so it can be shared with the students in it. If a trainer does not sign in, no upload occurs and the recording stays only on their own computer.</p>

      <p><strong>Data collected:</strong> when signed in, the extension sends the trainer's login credentials (for authentication), the trainer's name (to label the upload), and the recording file itself to Koderbox's own servers. No data is sent to any third party, and no data is collected when the trainer is not signed in.</p>

      <p><strong>Retention and access:</strong> uploaded recordings are stored in Koderbox's class-management system and are accessible to the trainer, the enrolled students of that class, and Koderbox administrators, consistent with normal access to any other class material.</p>

      <h4>6. Changes to This Privacy Policy</h4>
      <p>We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.</p>

      <h4>7. Contact Us</h4>
      <p>If you have any questions or suggestions about our Privacy Policy, please contact us.</p>

      {/* You should add more sections based on your website's specific practices. */}
    </div>
    </div>
    <Footer value={data} />
    <MetaTags
      title={"Privacy Policy | Koderbox"}
      description="How Koderbox collects, uses, and protects your personal data, including data practices for the Koderbox Meet Recorder Chrome extension."
      path="/privacypolicy/"
    />
    </>
  );
};

export default PrivacyPolicy;
